var map = {
	"./newMaterialArticle.vue": "20c5",
	"./newMaterialArticleDetail.vue": "cc58",
	"./newMaterialAssess.vue": "265c",
	"./newMaterialDetail.vue": "1d50",
	"./newMaterialFaceRec.vue": "c511",
	"./newMaterialLoad.vue": "6f8f",
	"./newMaterialNoResult.vue": "c08d",
	"./newMaterialTag.vue": "7cb0",
	"./newMaterialVoiceRec.vue": "3dce",
	"./newMaterialXl.vue": "a89f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d1e7";